import { createSelector } from '@reduxjs/toolkit';
import { PAY_BTN_STATUSES } from "../../../constants/payment";
import { FPS_ICON } from "../../../constants/const";
var getFPSState = function getFPSState(state) {
  return state.fps;
};
export var getPayData = function getPayData(state) {
  return getFPSState(state).payData;
};
export var getPaymentStatus = function getPaymentStatus(state) {
  return getFPSState(state).paymentStatus;
};
export var getQRScanResult = function getQRScanResult(state) {
  return getFPSState(state).qrScan;
};
export var getIsOpen = function getIsOpen(state) {
  return getFPSState(state).isOpen;
};
export var getFPSData = function getFPSData(state) {
  return getFPSState(state).fpsData;
};
export var getFPSDataContent = function getFPSDataContent(state) {
  var _getFPSData;
  return (_getFPSData = getFPSData(state)) === null || _getFPSData === void 0 ? void 0 : _getFPSData.content;
};
export var getFPSIcon = function getFPSIcon(state) {
  var _getFPSData2;
  return ((_getFPSData2 = getFPSData(state)) === null || _getFPSData2 === void 0 || (_getFPSData2 = _getFPSData2.content) === null || _getFPSData2 === void 0 || (_getFPSData2 = _getFPSData2.sfpMethod) === null || _getFPSData2 === void 0 ? void 0 : _getFPSData2.iconSrc) || FPS_ICON;
};
export var getFPSBindingEnabled = function getFPSBindingEnabled(state) {
  var _getFPSData3;
  return ((_getFPSData3 = getFPSData(state)) === null || _getFPSData3 === void 0 ? void 0 : _getFPSData3.bindingEnabled) || false;
};
export var getFPSBindingList = function getFPSBindingList(state) {
  var _getFPSState$fpsBindi;
  return ((_getFPSState$fpsBindi = getFPSState(state).fpsBindingData) === null || _getFPSState$fpsBindi === void 0 ? void 0 : _getFPSState$fpsBindi.list) || [];
};
export var getFPSAddBindingAllowed = function getFPSAddBindingAllowed(state) {
  var _getFPSState$fpsBindi2;
  return (_getFPSState$fpsBindi2 = getFPSState(state).fpsBindingData) === null || _getFPSState$fpsBindi2 === void 0 ? void 0 : _getFPSState$fpsBindi2.addSbpBindingAllowed;
};
export var getFPSPendingBinding = function getFPSPendingBinding(state) {
  return getFPSState(state).pendingBinding;
};
export var getFPSMappedBindingList = createSelector([getFPSBindingList, getFPSIcon], function (bindingList, fpsIcon) {
  return bindingList.map(function (bankItem) {
    return {
      id: "fpsBinding-".concat(bankItem.bindingId),
      title: "\u0421\u0411\u041F \u2022 ".concat(bankItem.bankName),
      iconSrc: fpsIcon,
      cardNumber: '',
      bindingId: bankItem.bindingId
    };
  });
});
export var getTurnedOnFPSScenario = createSelector([getIsOpen, getPaymentStatus], function (isOpen, paymentStatus) {
  return !!isOpen || paymentStatus === PAY_BTN_STATUSES.error;
});